import React, { useEffect, useState } from 'react';
import { useParams, Redirect } from 'react-router-dom'
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Button, Link } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import axios from 'axios';
import AppTagChipArrayTop from './AppTagChipArrayTop';
import AppTagChipArrayBottomCard from './AppTagChipArrayBottomCard';
import Grid from "@material-ui/core/Grid";
import CardManager from '../CardManager';
import AppInsideCard from '../AppInsideCard';
import AppCardBNList from './AppCardBNList';
import translate from '../../other/translate.json';
import icons_bn from '../../other/icons_bn.json';
import Collapse from '@material-ui/core/Collapse';
import EventIcon from '../../icons/EventIcon'
import ArrowlinkIcon from '../../icons/ArrowlinkIcon'
import Helmet from "react-helmet";
import ChevronIcon from '../../icons/ChevronIcon';
import SkeletonInsideCard from '../Skeleton/SkeletonInsideCard';
import SkeletonBlock from '../Skeleton/SkeletonBlock';
import AppCardTab from './AppCardTab';
import Snackbar from '@material-ui/core/Snackbar';
import TagIcon from '../../icons/TagIcon';
import AppTagChipArrayBottom from './AppTagChipArrayBottom';
import AppCardTagList from './AppCardTagList';
import config from '../../other/config';
import DocIcon from '../../icons/DocIcon';
import VideoIcon from '../../icons/VideoIcon';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import NavigateBeforeIcon from '../../icons/ArrowLeftIcon';
import ExtensionIcon from '@material-ui/icons/Extension';
import ChangeViewArray from '../ChangeViewArray';
import AllAppsTile from '../Applications/AllAppsTile';
import AllAppsTable from "../Applications/AllAppsTable";
import AddAllAppsIcon from '../../icons/AddAllAppsIcon';
import Switch from '@material-ui/core/Switch';
// import PageNotFound from "../Errors/PageNotFound";

let moment = require('moment');
require("moment/min/locales.min");


const { serverAPI } = config;

const CustomTooltip = withStyles((theme) => ({
	tooltip: {
		backgroundColor: 'rgba(60, 60, 86, 0.8)',
		color: '#FFFFFF',
		boxShadow: 'none',
		padding: 12,
		borderRadius: 8,
		fontWeight: 'normal',
		fontSize: '12px',
		lineHeight: '14px',
	},
}))(Tooltip);

export default function AppCard(props) {
	let { setAppBasket, basketChips } = props
	let { code } = useParams();
	let lang = localStorage.getItem('language') || 'Ru';
	let searchParams = new URLSearchParams(window.location.search);
	lang === 'Ru' ? moment.locale(`ru`) : moment.locale(`eng`)
	const isRu = lang === 'Ru'
	const classes = useStyles();
	// window.scrollTo(0, 0)
	const [app, setApp] = useState({});
	const [num, setNum] = useState([]);
	const [dynamics, setDynamics] = useState([]);
	const [notFound, setNotFound] = useState(false);
	const [expanded, setExpanded] = React.useState(false);
	let [countDynamics, setCountDynamics] = useState(0);
	let [template, setTemplate] = useState([]);
	let [overtemplate, setOverTemplate] = useState([]);
	const [kloStatuses, _kloStatuses] = useState({});
	const [appIncludeIn, _appIncludeIn] = useState(false);
	// let tagsName = app.tags_q ? app.tags_q.split(',').map(el => el.split('#;')[0]).join() : '';
	let tagsName = app.Tags ? app.Tags.split(',').map(el => el.split('#;')[0]).join() : '';
	const [loading, setloading] = React.useState(true);
	const [arrayTag, setArrayTags] = useState(JSON.parse(localStorage.getItem('AppsArrayTag')) || []);
	const [appRecom, _RecomApp] = useState();
	const [loadingKloStatuses, _loadingKloStatuses] = useState(false);
	let [view, _view] = useState(localStorage.getItem('view') || 'table');
	const [snackbar, _snackbar] = React.useState(false);
	const [allRecCheckBox, _allRecCheckBox] = useState(false);
	const [checkAllRec, _checkAllRec] = useState(false);
	const [collapseRecomendedApps, _collapseRecomendedApps] = React.useState(false);
	const [alternatives, _alternatives] = useState();

	const setView = (index) => {
		_view(index)
		localStorage.setItem('view', index)
	}

	function handleExpandClick() {
		setExpanded(!expanded);
	};

	function closeSnackbar(event, reason) {
		if (reason === 'clickaway') {
			return;
		}

		_snackbar(false);
	};

	function setAppBasketSnackbar(app) {
		_snackbar(true);
		setAppBasket(app)
	}

	useEffect(() => {
		if (props.userCollection.inCu !== "0" && searchParams.has("RUB", "1")) {
			return props.userCollection.setCurrency
		}

		if (props.userCollection.inCu !== "1" && searchParams.has("RUB", "0")) {
			return props.userCollection.setCurrency
		}
	});

	useEffect(() => {
		let didCancel = false;
		setloading(true)
		async function fetchData() {
			const dataAllDynamics = await axios.get(`${serverAPI}/dynamic/${code}/${lang}`)
			const dataAllSection = await axios.get(`${serverAPI}/application/${code}/${lang}?inCu=${props.userCollection.inCu}`)
			//const appIncludeIn = await axios.get(`${serverAPI}/find/${lang}?q=${code}&inCu=${props.userCollection.inCu}`);

			if (!didCancel) {
				if (dataAllDynamics && dataAllDynamics.data && dataAllDynamics.data.length > 0) {
					setDynamics(dataAllDynamics.data)
					setCountDynamics(dataAllDynamics.data.length > 3 ? 4 : dataAllDynamics.data.length)
				}

				if (dataAllSection && dataAllSection.data && dataAllSection.data[0]) {
					setApp(dataAllSection.data[0])
					setNum(dataAllSection.data[0].Rating && dataAllSection.data[0].Rating.length > 2 ? dataAllSection.data[0].Rating.match(/\d+/g, '') : '')
					setNotFound(false)

					let apps = []

					const getDependency = await axios.post(`${serverAPI}/dependency`, { codeasvul: [dataAllSection.data[0].ID] });

					if (getDependency && getDependency.data) {
						getDependency.data.map(el => {
							if (el.ID !== dataAllSection.data[0].ID) {
								apps.push(el.ID)
							}
						})

						const dependent_apps = await axios.post(`${serverAPI}/apps?inCu=${props.userCollection.inCu}`,
							{
								apps: apps.join(','),
								lang: lang
							});

						if (dependent_apps && dependent_apps.data) {
							_RecomApp(dependent_apps.data)
						}
					}

					const dataAppAnalogs = await axios.post(`${serverAPI}/appAnalogs`, { appID: dataAllSection.data[0].ID }).then(res => {
						if (res.status === 200) {
							if (res.data.getData.length > 0) {
								_alternatives(res.data.getData);
							}
							props.userCollection.showTestId()
						} else {
							console.error('appAlternatives', res);
						}
					})
				} else {
					setApp([])
					setNotFound(true)
				}

				let cur = dataAllSection.data[0].Currency;
				if (/*userCollection.inCu === '1' && ![0,2].includes(cur) || userCollection.inCu !== '1' && ![1,2].includes(cur)  */ cur !== 2) {
					//console.log('setCu', userCollection._CatalogCu)
					props.userCollection._CatalogCu(cur === 1 ? '0' : '1')
				}

				if (dataAllSection.data[0] && dataAllSection.data[0].isIncludeInCatalogs === 1) {//appIncludeIn && appIncludeIn.data && (appIncludeIn.data.Products.length > 0 || appIncludeIn.data.Solutions.length > 0)) {
					_appIncludeIn(true);
				}
				setloading(false)
			}
		}
		fetchData();
		return () => {
			didCancel = true;
		}
	}, [code, lang]);

	useEffect(() => {
		let didCancel = false;
		async function fetchData() {
			let { kloUser } = props;
			if (kloUser && kloUser.user) {
				const statuses = await props.getKloStatuses(code)
				_kloStatuses(statuses)
			}
		}
		fetchData();
		return () => {
			didCancel = true;
		}
	}, [props.kloUser]);

	function dataShow(el, count) {
		let template_push = []
		let overtemplate_push = []

		if (el && el.length > 0) {
			for (let i = 0; i < count; i++) {
				template_push.push(
					<Grid item className={classes.DevelopmentDynamicsBlock}>
						<Typography component="p" className={classes.DevelopmentDynamicsBlockCaption}>{el[i].DateVersion}, {el[i].VersionDyn} </Typography>

						<Typography component="p" className={classes.DevelopmentDynamicsBlockBody} dangerouslySetInnerHTML={{ __html: el[i].BriefDescription }} />
					</Grid>
				)
			}
			setTemplate(template_push)
		}

		if (el && el.length > count) {
			for (let i = count; i <= el.length - 1; i++) {
				overtemplate_push.push(
					<Grid item className={classes.DevelopmentDynamicsBlock}>
						<Typography component="p" className={classes.DevelopmentDynamicsBlockCaption}>{el[i].DateVersion}, {el[i].VersionDyn} </Typography>

						<Typography component="p" className={classes.DevelopmentDynamicsBlockBody} dangerouslySetInnerHTML={{ __html: el[i].BriefDescription }} />
					</Grid>
				)
			}
			setOverTemplate(overtemplate_push)
		}
	}

	useEffect(() => { // codeerr что-то тут не так
		dataShow(dynamics, countDynamics)
	}, [dynamics, countDynamics])

	const renderFiles = () => {
		try {
			const renderDocLink = (link) => {
				return (
					<Link href={`https://catalog.cft.ru${link}`} rel="noopener noreferrer" target="_blank">
						<Grid item className={classes.attachContainer} >
							<DocIcon fill={'#BCBBD0'} />

							<Typography component="p" className={classes.descriptionAttach} >
								Презентация
							</Typography>
						</Grid>
					</Link>
				)
			}

			const renderVideoLink = (link) => {
				return (
					<Link href={`https://catalog.cft.ru${link}`} rel="noopener noreferrer" target="_blank">
						<Grid item className={classes.attachContainer}>
							<VideoIcon fill={'#BCBBD0'} />
							<Typography component="p" className={classes.descriptionAttach} >
								Видео
							</Typography>
						</Grid>
					</Link>
				)
			}
			if (isRu && ((app.path_video !== '' && app.path_video !== undefined && app.path_video !== null) || (app.path_prezi !== '' && app.path_prezi !== undefined && app.path_prezi !== null))) {
				return (
					<Grid container direction="row" className={classes.attachWrapper}>

						{
							(app.path_prezi !== '' && app.path_prezi !== undefined && app.path_prezi !== null)
								?
								app.path_prezi.split(';').map((link, index) => {
									if (index > 0) {
										return (
											renderDocLink(link)
										)
									}
								})
								:
								null}
						{(app.path_video !== '' && app.path_video !== undefined && app.path_video !== null) ?
							app.path_video.split(';').map((link, index) => {
								if (index > 0) {
									return (
										renderVideoLink(link)
									)
								}
							})
							:
							null}
					</Grid>
				)
			}
		} catch (e) {
			console.log("error", e)
		}
	}

	function handleClickBreadcrumb(event) {
		event.preventDefault();
		console.info('You clicked a breadcrumb.');
	}

	const setArrayTag = (arr) => {
		setArrayTags(arr)
		localStorage.setItem('AppsArrayTag', JSON.stringify(arr))
	}

	function blockLicensed() { // Блок Лицензировано
		return (
			<Grid item container className={classes.LicensedContainer} id="AppCard-Licensed">
				<Grid item>
					<Typography variant="body2" color="textSecondary" component="p" className={classes.contentHeader}>
						{+num[6] > 0 ?
							+num[6] > 1 ? translate.Words[`LicensedBy${lang}`] + ' ' + num[6] + ' ' + translate.Words[`bank${lang}`] + translate.Words[`banks${lang}`]
								: translate.Words[`LicensedBy${lang}`] + ' ' + num[6] + ' ' + translate.Words[`bank${lang}`]
							// +num[6] > 1 ? num[6] + translate.Words[`bank${lang}`]  + translate.Words[`banks${lang}`] : num[6] +' '+ translate.Words[`bankG${lang}`] 
							: ''}
					</Typography>
				</Grid>

				<Grid item container direction="row" alignItems="center" xs={12} style={{ justifyContent: 'center', marginTop: 39, padding: '0 200px' }}>
					{
						num[1] > 0
							?
							<Grid item style={{ width: 120, marginRight: 56 }}>
								<React.Fragment>
									<Grid item container direction="column" justify="center" alignItems="center" className={classes.rectangle593}>
										<Grid item style={{ fontFamily: 'Cera CY', fontStyle: 'normal', fontWeight: 'normal', fontSize: '13px', lineHeight: '16px', color: '#FFFFFF', opacity: 0.5 }}>{translate.Words[`Top${lang}`]} </Grid>
										<Grid item style={{ fontFamily: 'Cera CY', fontStyle: 'normal', fontWeight: 500, fontSize: '28px', lineHeight: '40px', color: '#FFFFFF' }}>{+num[0] > 0 ? num[0] : ''}  </Grid>
									</Grid>

									<Typography variant="body2" color="textSecondary" component="p" style={{ fontFamily: 'Cera CY', fontStyle: 'normal', fontWeight: 500, fontSize: '18px', lineHeight: '28px', color: '#000000', textAlign: 'center', marginTop: 16, minHeight: 28 }}>
										{num[1] > 0 ? +num[1] > 1 ? num[1] + ' ' + translate.Words[`bank${lang}`] + translate.Words[`banks${lang}`] : num[1] + ' ' + translate.Words[`bankG${lang}`] : ''}
									</Typography>
								</React.Fragment>
							</Grid>
							:
							null
					}

					{
						num.length > 1 && num[3] > 0
							?
							<Grid item style={{ width: 120, marginRight: 56 }}>
								<React.Fragment>
									<Grid item container direction="column" justify="center" alignItems="center" className={classes.rectangle593} style={{ opacity: 0.8 }}>
										<Grid item style={{ fontFamily: 'Cera CY', fontStyle: 'normal', fontWeight: 'normal', fontSize: '13px', lineHeight: '16px', color: '#FFFFFF', opacity: 0.5 }}>{translate.Words[`Top${lang}`]} </Grid>
										<Grid item style={{ fontFamily: 'Cera CY', fontStyle: 'normal', fontWeight: 500, fontSize: '28px', lineHeight: '40px', color: '#FFFFFF' }}>{num[2] > 0 && num[2] ? num[2] : ''}  </Grid>
									</Grid>

									<Typography variant="body2" color="textSecondary" component="p" style={{ fontFamily: 'Cera CY', fontStyle: 'normal', fontWeight: 500, fontSize: '18px', lineHeight: '28px', color: '#000000', textAlign: 'center', marginTop: 16, minHeight: 28 }}>
										{num[3] > 0 ? +num[3] > 1 ? num[3] + ' ' + translate.Words[`bank${lang}`] + translate.Words[`banks${lang}`] : num[3] + ' ' + translate.Words[`bankG${lang}`] : ''}
										{/* {num.length > 1 && num[3] ? num[3] + translate.Words[`bank${lang}`] + num[3] > 0 ? translate.Words[`banks${lang}`] : `` : ''} */}
									</Typography>
								</React.Fragment>
							</Grid>
							:
							null
					}

					<Grid item style={{ width: 120 }}>
						{
							num.length > 1 && num[5] > 0
								?
								<React.Fragment>
									<Grid item container direction="column" justify="center" alignItems="center" className={classes.rectangle593} style={{ opacity: 0.6 }}>
										<Grid item style={{ fontFamily: 'Cera CY', fontStyle: 'normal', fontWeight: 'normal', fontSize: '13px', lineHeight: '16px', color: '#FFFFFF', opacity: 0.5 }}>{translate.Words[`Top${lang}`]}  </Grid>
										<Grid item>
											<Typography style={{ fontFamily: 'Cera CY', fontStyle: 'normal', fontWeight: 500, fontSize: '28px', lineHeight: '40px', color: '#FFFFFF' }}>{num.length > 1 && num[4] ? num[4] : ''}  </Typography>
										</Grid>
									</Grid>

									<Typography variant="body2" color="textSecondary" component="p" style={{ fontFamily: 'Cera CY', fontStyle: 'normal', fontWeight: 500, fontSize: '18px', lineHeight: '28px', color: '#000000', textAlign: 'center', marginTop: 16, minHeight: 28 }}>
										{num[5] > 0 ? +num[5] > 1 ? num[5] + ' ' + translate.Words[`bank${lang}`] + translate.Words[`banks${lang}`] : num[5] + ' ' + translate.Words[`bankG${lang}`] : ''}
									</Typography>
								</React.Fragment>
								:
								null
						}
					</Grid>
				</Grid>
			</Grid>
		)
	}

	function renderAppIncludeIn() {
		if (appIncludeIn) {
			return (
				<React.Fragment>
					<ExtensionIcon style={{ marginRight: '8px', color: '#8987A2' }} />

					<Link
						href={`/search?q=${app['CodeAsvul']}&t=4`}
						target='_blank'
						rel="noopener noreferrer"
						className={classes.LinkType21}
					>
						{translate.Words[`AppIncludeIn_${lang}`]}
					</Link>
				</React.Fragment>
			)
		}
	}

	function renderAddAllBascetBtn() {
		if (!appRecom.every(elem => props.userCollection.appBasket.includes(elem.ID))) {
			return (
				<Grid item style={{ paddingRight: 24 }}>
					<Button aria-label="delete" className={classes.margin} size="small"
						onClick={(e) => choiseAll(e)}
						style={{
							height: 48,
							display: allRecCheckBox ? 'none' : ''
						}}
					>
						<AddAllAppsIcon fill={'#BCBBD0'} fontSize="inherit" />

						<Typography style={{ marginLeft: 16, color: '#8987A2', textTransform: 'none' }}>{translate.Words[`AddAllToBasket${lang}`]}</Typography>
					</Button>
				</Grid>
			)
		}
	}

	const choiseAll = async (event) => {
		let newCardID = appRecom.filter(elem => elem.researchmarket === '' && !props.userCollection.appCartInProduct.includes(elem.ID)).map(elem => elem.ID)
		let basketApps_ = props.userCollection.appBasket;
		let basketApp = allRecCheckBox ? basketApps_.filter(item => !newCardID.includes(item)) : basketApps_.concat(newCardID.filter(item => !basketApps_.includes(item)));
		props.saveCollection(basketApp, 'app', 'cart', undefined, true);
		_checkAllRec(!checkAllRec)

		if (!allRecCheckBox) {
			let deltaApps = basketApp.length - basketApps_.length;
			props.handleCloseCookieSnackbar();
			_snackbar([true, translate.Words[`AddtoCartApps_${lang}`] + ": " + deltaApps])
		}
	}

	const handleChange = () => {
		_collapseRecomendedApps((prev) => !prev);
	};

	let helmetTitle = app && app[`appTitle`] ? `${app[`appTitle`]} | ${app.CodeAsvul} | ${app[`catalog_title`]}` : ' | ' + window.location.href.split('/card/')[1] + ' | '

	return (
		<React.Fragment>
			<Helmet
				title={helmetTitle}
			/>
			{
				notFound
					?
					<Redirect to="/pagenotfound" />
					:
					<Grid item container>
						{
							(window.location.pathname.slice(1, 5) == "appl" || window.location.pathname.slice(1, 5) == "sear" || window.location.pathname.slice(1, 5) == "cart")
								?
								<Grid item container style={{ margin: '36px 0', alignItems: 'center' }}>
									{
										loading === true
											?
											<SkeletonBlock height={24} width={25} />
											:
											<div> <NavigateBeforeIcon mb={'-7px'} fontSize="normal" fill="#BCBBD0" /> <a href={`/applications/${app.url_catalog}/overview`} className={classes.Breadcrumb}>{app.catalog_title}</a> | <a href={`/${props.type}/${app['url_catalog']}/applist?filt=false&direction=${app['icon_id_bn']}`} className={classes.Breadcrumb}>{app.TitleBN}</a> | <a href={`/${props.type}/${app['url_catalog']}/applist?filt=false&direction=&section=${app['SECTION_ID']}`} className={classes.Breadcrumb}>{app.Title}</a> | <span style={{ fontSize: '16px' }}>{app[`appTitle`]}</span></div>

										// <Breadcrumbs separator="|" aria-label="breadcrumb" className={classes.BC}>
										// 	<Grid item container style={{ maxHeight: 24, fontSize: '16px', lineHeight: '24px', color: '#8987A2', width: 'max-content' }}>
										// 		<Grid item>
										// 			<NavigateBeforeIcon fontSize="normal" fill="#BCBBD0" />
										// 		</Grid>

										// 		<Grid item>
										// 			<Link color="inherit" className={classes.Breadcrumb} href={`/applications/${app.url_catalog}/overview`} onClick={() => handleClickBreadcrumb} style={{ lineHeight: '24px' }}>
										// 				{app.catalog_title}
										// 			</Link>
										// 		</Grid>
										// 	</Grid>

										// 	<Link color="inherit" className={classes.Breadcrumb} href={`/${props.type}/${app['url_catalog']}/applist?filt=false&direction=${app['icon_id_bn']}`} onClick={() => handleClickBreadcrumb}>
										// 		{app.TitleBN}
										// 	</Link>

										// 	<Link color="inherit" className={classes.Breadcrumb} href={`/${props.type}/${app['url_catalog']}/applist?filt=false&direction=&section=${app['SECTION_ID']}`} onClick={() => handleClickBreadcrumb}>
										// 		{app.Title}
										// 	</Link>

										// 	<Typography color="#8987A2">{app[`appTitle`]}</Typography>
										// </Breadcrumbs>
									}
								</Grid>
								:
								<Grid item container style={{ height: 96 }}></Grid>
						}

						<Card className={classes.rootWide}>
							<Grid item container className={classes.TopTagArray} direction="row" justify="flex-end">
								{app.event ?
									<React.Fragment>
										<Grid item className={classes.EventCntr}>
											<a href={app.event} _blank rel="noopener noreferrer" color="inherit" style={{ display: 'flex', textDecoration: 'none' }}>
												<EventIcon fill='#BCBBD0' />
												<Typography className={classes.LinkType2}>{translate.Words[`Events${lang}`]}</Typography>
												<ArrowlinkIcon fill='#BCBBD0' />
											</a>
										</Grid>

										<Grid item style={{ paddingLeft: 8 }}>
											<AppTagChipArrayTop
												position='topCard'
												key={code}
												variant={1}
												isStandant={app.standartpackage}
												isResearchMarket={app.researchmarket}
												isCloudApp={app.isCloudApp}
												promo={app.promo}
												dataEndSale={app.dateendsale1}
												announcement={app.announcement}
												event={app.StockLink}
												isNew={app.isNew}
											/>
										</Grid>
									</React.Fragment>
									:
									<Grid item style={{ paddingLeft: 8 }}>
										<AppTagChipArrayTop
											position='topCard'
											key={code}
											variant={1}
											isStandant={app.standartpackage}
											isResearchMarket={app.researchmarket}
											isCloudApp={app.isCloudApp}
											promo={app.promo}
											dataEndSale={app.dateendsale1}
											announcement={app.announcement}
											event={app.StockLink}
											isNew={app.isNew}
										/>
									</Grid>
								}
							</Grid>

							{/* <Grid container direction="row" justify="space-between" alignItems="flex-start" className={classes.MainInfoCntr} style={{ marginTop: 26, maxWidth: 1096, margin: 'auto', outline: '1px solid green' }}> */}
							<Grid container direction="row" alignItems="flex-start" justify="space-between" className={classes.AppInfoContainer}>
								<Grid container className={classes.BaseInfoContainer}>
									<Grid container direction="row" justify="flex-start" alignItems="flex-start" id="AppTitleCntr">
										<Grid item className={classes.AvatarContainer}>
											<Avatar aria-label="recipe" className={classes.avatar}
												style={{ backgroundColor: app.Color && app.Color.length > 5 ? `#${app.Color}` : '#E45670' }}
												src={icons_bn[`${app.icon_id_bn}`]}></Avatar>
										</Grid>

										<Grid item className={classes.AppNameContainer}>
											<Typography className={classes.title}>
												{app[`appTitle`]}
											</Typography>
										</Grid>
									</Grid>

									<Grid
										id="AppInfoCntr"
										container
										direction="column"
										justify="flex-start"
										alignItems="flex-start"
										style={{ marginTop: 40 }}
									>
										<Grid item container
											direction="row"
											justify="space-between"
											alignItems="flex-start"
											style={{ marginTop: 40 }}
										>
											<Grid item className={classes.cntrSection}>
												<Typography className={classes.subheader}>
													{translate.Words[`Section${lang}`]}
												</Typography>
												{
													loading === true
														?
														<SkeletonBlock height={24} />
														:
														(window.location.pathname.slice(1, 5) == "appl" || window.location.pathname.slice(1, 5) == "sear" || window.location.pathname.slice(1, 5) == "cart")
															?
															<Link
																href={`/${props.type}/${app['url_catalog']}/applist?filt=false&direction=&section=${app['SECTION_ID']}`}
																className={classes.LinkType12}
															>
																{app.Title}
															</Link>
															:
															<Typography className={classes.subbody}>
																{app.Title}
															</Typography>
												}
											</Grid>

											<Grid item style={{ alignItems: 'center', display: 'flex' }}>
												{window.innerWidth < 1702 && window.innerWidth > 695 ? renderAppIncludeIn() : null}
											</Grid>
										</Grid>

										<Grid item container style={{ marginTop: 25 }}>
											<Grid item container alignItems="center">
												<Typography component="p" className={classes.subheader}>
													{translate.Words[`BusinessArea${lang}`]}
												</Typography>

												{
													loading === true
														?
														<SkeletonBlock height={24} />
														:
														app.businessdirectionadditional && app.businessdirectionadditional.length > 1
															?
															<AppCardBNList BusinessDirectionAdditional={app.businessdirectionadditional} />
															:
															null
												}
											</Grid>

											{
												props.type
													?
													<Link
														href={`/${props.type}/${app['url_catalog']}/applist?filt=false&direction=${app['icon_id_bn']}`}
														className={classes.LinkType12}
													// underlineNone
													// color="inherit"
													// underline="none"
													>
														{/* <Typography className={classes.subbody}> */}
														{app.TitleBN}
														{/* </Typography> */}
													</Link>
													:
													<Typography className={classes.subbody}>
														{app.TitleBN}
													</Typography>
											}
										</Grid>

										<Grid item container>
											<Grid
												container
												direction="row"
												justify="flex-start"
												alignItems="flex-start"
												spacing={3}
												style={{ marginTop: 13 }}
											>
												{app.IsResearchMarket === 1 ? '' :
													<Grid item sm={4} xs={12}>
														<Typography className={classes.subheader}>
															{translate.Words[`ApplicationCode${lang}`]}
														</Typography>

														<Typography className={classes.subbody} style={{ marginTop: 1 }}>
															{app.CodeAsvul}
														</Typography>
													</Grid>
												}

												<Grid item sm={8} xs={12}>
													<Grid
														container
														direction="row"
														justify="flex-start"
														alignItems="flex-start"
														spacing={3}
													>
														{app.IsResearchMarket === 1 ? '' :
															<Grid item className={classes.cntrArchitecture} style={{ minWidth: 198 }}>
																<Typography className={classes.subheader}>
																	{translate.Words[`Version${lang}`]}
																</Typography>

																<Typography component="p" className={classes.subbody}>{app.Version !== undefined ? app.Version : null}</Typography>
															</Grid>
														}

														<Grid item className={classes.cntrInterface}>
															<Typography component="p" className={classes.subheader}>{translate.Words[`ApplicationType${lang}`]} </Typography>
															<Typography component="p" className={classes.subbody}>{app.Type}</Typography>
														</Grid>
													</Grid>
												</Grid>
											</Grid>
										</Grid>

										{app.IsResearchMarket === 1
											?
											null
											:
											<Grid item container>
												<Grid
													container
													direction="row"
													justify="flex-start"
													alignItems="flex-start"
													spacing={3}
													style={{ marginTop: 12 }}
												>
													<Grid item container direction='column' spacing={3} sm={4} xs={12} style={{ marginRight: 12 }}>
														<Grid item sm={12} xs={6}>
															<Typography className={classes.subheader}>
																{translate.Words[`Date${lang}`]}
															</Typography>

															<Typography className={classes.subbody} style={{ marginTop: 1 }}>
																{app.DateStartSale}
															</Typography>
														</Grid>
													</Grid>

													<Grid item sm={8} xs={12}>
														<Typography className={classes.subheader}>
															{translate.Words[`Require${lang}`]}
														</Typography>
														{
															(app[`Requirement`] && app[`Requirement`].includes('выше')) || (app[`Requirement`] && app[`Requirement`].includes('above')) ?
																<CustomTooltip title={lang === 'Ru' ? 'Все Обновления Основного выпуска СИСТЕМЫ, официально выпущенные позже указанной версии' : "Updates of the Main SYSTEM issue officially released after this edition"}>
																	<Typography className={classes.subbodyRequire} style={{ marginTop: 1 }} dangerouslySetInnerHTML={{ __html: app[`Requirement`] }} />
																</CustomTooltip>
																:
																<Typography className={classes.subbodyRequire} style={{ marginTop: 1 }} dangerouslySetInnerHTML={{ __html: app[`Requirement`] }} />
														}
													</Grid>
												</Grid>
											</Grid>
										}

										<Grid item container>
											<Grid
												container
												direction="row"
												justify="flex-start"
												alignItems="flex-start"
												spacing={3}
												style={{ marginTop: 12 }}
											>
												{app.DateEndSale && '1900-01-01T00:00:00.000Z' !== app.DateEndSale
													?
													<Grid item sm={4} xs={12}>
														<Typography className={classes.subheader}>
															{translate.Words[`ArchivedAt${lang}`]}
														</Typography>

														<Typography className={classes.subbody} style={{ marginTop: 1 }}>
															{app.DateEndSale}
														</Typography>
													</Grid>
													:
													<Grid item sm={4} xs={12} />
												}

												{app.IsResearchMarket !== 1 && app.Architecture && app.Architecture.length > 0 ?
													<Grid item className={classes.cntrArchitecture}>
														<Typography className={classes.subheader}>
															{translate.Words[`Architecture${lang}`]}
														</Typography>

														<Typography className={classes.subbody} style={{ marginTop: 1 }}>
															{app.Architecture}
														</Typography>

														<Typography className={classes.subbody} style={{ marginTop: 1 }}>
															{app.ArchitectureAdditional}
														</Typography>
													</Grid>
													: ''
												}

												{app.IsResearchMarket !== 1 && app.Interface && app.Interface.length > 0 ?
													<Grid item className={classes.cntrInterface}>
														<Typography className={classes.subheader}>
															{translate.Words[`Interface${lang}`]}
														</Typography>

														<Typography className={classes.subbody} style={{ marginTop: 1 }}>
															{app.Interface}
														</Typography>

														<Typography className={classes.subbody} style={{ marginTop: 1 }}>
															{app.InterfaceAdditional}
														</Typography>
													</Grid>
													: ''
												}
											</Grid>
										</Grid>

										{/* {loading === true
										?
										<Grid item className={classes.BriefDescription}>
											<SkeletonBlock height={48} />
										</Grid>
										:
										app[`BriefDescription`] && app[`BriefDescription`].length > 0 ?
											<Grid item className={classes.BriefDescription} style={{background: 'red'}}>
												<Typography className={classes.contentBody} dangerouslySetInnerHTML={{ __html: app[`BriefDescription`] }}></Typography>
											</Grid>
											: ''
									} */}
										<Grid></Grid>
									</Grid>
								</Grid>

								<Grid container className={classes.AppInsideCardContainer}>
									{loading === true
										?
										<SkeletonInsideCard />
										:
										<AppInsideCard
											isAuth={props.isAuth}
											usname={props.usname}
											// DateEndSale={DateEndSale}
											CodeAsvul={app.CodeAsvul}
											setAppBasket={setAppBasketSnackbar}
											basketChips={basketChips}
											asvul={app}
											IsResearchMarket={app.IsResearchMarket}
											DateStartStock={app.DateStartStock}
											DateEndSaleStock={app.DateStartStock}
											price1={app.PaymentOne}
											price2={app.PaymentMonthly}
											price3={app.PaymentOneStock}
											price4={app.PaymentMonthlyStock}
											ResearchMarketMails={app.RESEARCHMARKETMAILS}
											lang={lang}
											price1Com={app[`PaymentComment`]}
											price2Com={app[`PaymentCommentOne`]}
											price3Com={app[`PaymentCommentMonthly`]}
											paymentcomment1={app[`paymentcomment1`]}
											paymentcommentone1={app[`paymentcommentone1`]}
											paymentcommentmonthly1={app[`paymentcommentmonthly1`]}
											PaymentOneStock={app[`PaymentOne`]}
											PaymentMonthlyStock={app[`PaymentMonthly`]}
											dateendsale1={app[`dateendsale1`]}
											loading={loading}
											app={app}
											userCollection={props.userCollection}
											saveCollection={props.saveCollection}
											kloStatus={kloStatuses && kloStatuses[code] ? kloStatuses[code] : ''}
											kloUser={props.kloUser}
											isHidePrice={app.isHidePrice}
										/>
									}

									<Grid item style={{ display: 'flex', margin: '0 auto', marginTop: '24px' }}>
										{window.innerWidth > 1701 || window.innerWidth < 696 ? renderAppIncludeIn() : null}
									</Grid>
								</Grid>
							</Grid>
							{/* </Grid> */}

							<Grid className={classes.ExtInfoContainer}>

								{tagsName && tagsName.length > 0
									?
									<Grid item container direction="row" justifyContent="flex-start" alignItems="center" className={classes.TagsInfoCntr}>
										<Grid item>
											<TagIcon fill={'#BCBBD0'} />
										</Grid>

										<Grid item>
											<AppCardTagList
												tagsQ={app.tags_q}
												setArrayTag={setArrayTag}
												arrayTag={arrayTag}
												card={true}
											/>
										</Grid>

										<hr />
									</Grid>
									:
									''
								}

								{app.TagsIDs && app.TagsIDs.length > 0 ?
									<Grid item container justify="flex-start" alignItems="center" style={{ height: 104, borderBottom: '1px solid #EEEEF5' }}>
										<AppTagChipArrayBottomCard position='middle' Tags={app[`Tags`]} icon={true} />
									</Grid>
									: ''
								}
								<CardContent className={classes.content}>
									<Grid container direction="column" justify="flex-start" alignItems="flex-start">
										<Grid item container className={classes.OutRDC}>
											{
												app[`HTMLContent`] && app[`HTMLContent`].length > 0
													?
													<Grid item>
														<Typography variant="body2" color="textSecondary" component="p" className={classes.contentBody} dangerouslySetInnerHTML={{ __html: app[`HTMLContent`] }}></Typography>
													</Grid>
													:
													null
											}
											{
												app[`HTMLFunction`] && app[`HTMLFunction`].length > 0 ?
													<Grid item xs={12} className={classes.KeyFunctionCntr}>
														<Typography variant="body2" color="textSecondary" component="p" className={classes.contentHeader}>
															{translate.Words[`KeyFunctions${lang}`]}
														</Typography>

														<Typography variant="body2" color="textSecondary" component="ul" className={classes.contentBodyLi} style={{ marginTop: 40, paddingInlineStart: 17 }}>
															<div dangerouslySetInnerHTML={{ __html: app[`HTMLFunction`] }}></div>
														</Typography>
													</Grid>
													:
													null
											}
										</Grid>

										{
											/^;/gmi.test(app['path_diagram']) || /^;/gmi.test(app['path_prezi']) || /^;/gmi.test(app['path_video']) ?
												<Grid item container className={classes.ExtraContainer}>
													<Grid item style={{ width: '100%' }}>
														<Typography variant="body2" color="textSecondary" component="p" className={classes.contentHeader}>
															{translate.Words[`Advanced${lang}`]}
														</Typography>
													</Grid>

													{/^;/gmi.test(app['path_diagram'])
														?
														<Grid item container justifyContent="flex-start" alignItems="center" style={{ marginTop: 40, width: '100%', overflowX: 'auto', overflowY: 'hidden', height: 370, flexDirection: 'column' }}>

															{/* // <Grid item container style={{ width: 'max-content' }}> */}
															{app['path_diagram'].replace(';', '').split(';').map(el =>

																<Grid item  >
																	<a style={{ float: 'left' }} href={`https://catalog.cft.ru/${el}`} target="_blank" rel="noopener noreferrer">
																		<img alt="" style={{ maxWidth: '100%', maxHeight: 363, paddingRight: 16 }} src={`https://catalog.cft.ru/${el}`} />
																	</a>
																</Grid >
															)}
															{/* // </Grid > */}

														</Grid>
														:
														null}
												</Grid>
												:
												null
										}
									</Grid>

									{renderFiles()}


									{
										code.slice(0, 2) !== '1L'
											?
											<Grid item style={{ marginTop: 40 }}>
												<Typography variant="body2" color="textSecondary" component="p" className={classes.contentBody}>
													{translate.Words[`Description1${lang}`]}
												</Typography>
											</Grid>
											:
											null
									}

									{/* ===== ВРЕМЕННО ОТКЛЮЧЕНО =============== */}
									{/* <Grid item container direction="column" xs={12} className={classes.block} style={{ marginTop: 77 }}>
									<Grid item>
										<Typography variant="body2" color="textSecondary" component="p" className={classes.contentHeader} style={{ marginBottom: 40 }}>
											С этим приложением:
										</Typography>
									</Grid>

									<Grid item>
										<AppCardTab
											theader0={'Продукты'}
											theader1={'Решения'}
											theader2={'Облачные сервисы'}
											block={'dops'}
											content0={'Продукты'}
											content1={'Решения'}
											content2={'Облачные сервисы'}
										/>
									</Grid>

									<Grid item></Grid>
								</Grid> */}
									{/* =============== ВРЕМЕННО ОТКЛЮЧЕНО ===== */}
									{
										num && num[6] && num[6] > 0
											?
											blockLicensed()
											:
											null
									}

									<Grid item container className={classes.OutRDC}>
										{dynamics.length > 0 ? <Grid item container direction="column" xs={12} className={classes.DevDynamicsContainer}>
											<Grid item>
												<Typography variant="body2" color="textSecondary" component="p" className={classes.contentHeader} style={{ paddingBottom: 20 }}>
													{translate.Words[`DynamicsOfDevelopment${lang}`]}
												</Typography>
											</Grid>

											<Grid item container direction="column">
												{/* <Button
													className={clsx(classes.expand, {
														[classes.expandOpen]: expanded,
													})}
													onClick={handleExpandClick}
													aria-expanded={expanded}
													aria-label="show more"
												> */}

												{/* </Button> */}
												{/* TODO ARH */}
												{/* показываем z значений map заменить на for (i=1 до i=z) */}

												{template}

												<Collapse in={expanded} timeout="auto" unmountOnExit>
													{overtemplate}
												</Collapse>

												{/* <Button
													className={clsx(classes.expand, {
														[classes.expandOpen]: expanded,
													})}
													onClick={handleExpandClick}
													aria-expanded={expanded}
													aria-label="show more"
													style={{ display: dynamics && dynamics.length > 4 ? '' : 'none' }}
												> */}
												<Grid item container direction="row"
													justify="flex-start"
													alignItems="center"
													style={{
														display: dynamics && dynamics.length > 4 ? '' : 'none',
													}}
												>
													<Grid
														item
														onClick={handleExpandClick}
														aria-expanded={expanded}
														style={{
															cursor: 'pointer',
															borderBottom: '1px solid #DEDDE8'
														}}
													>
														<Typography
															style={{
																fontFamily: 'Cera CY',
																fontStyle: 'normal',
																fontWeight: 'normal',
																fontSize: '16px',
																lineHeight: '24px',
																color: '#8987A2'
															}}
														>
															{expanded ? translate.Words[`Нide_${lang}`] : translate.Words[`ShowMore_${lang}`]}
														</Typography>
													</Grid>

													<Grid
														item
														onClick={handleExpandClick}
														aria-expanded={expanded}
														style={{
															cursor: 'pointer'
														}}
													>
														<ChevronIcon fill={'#BCBBD0'} transform={expanded ? 'rotate(270deg)' : 'rotate(90deg)'} />
													</Grid>

												</Grid>
												{/* </Button> */}

												{/* <Collapse in={expanded} timeout="auto" unmountOnExit>
													{dynamics.map(el => (
														<Grid item className={classes.DevelopmentDynamicsBlock}>
															<Typography component="p" className={classes.DevelopmentDynamicsBlockCaption}>{el["DateVersion"]}, {el["VersionDyn"]} </Typography>

															<Typography component="p" className={classes.DevelopmentDynamicsBlockBody}><div dangerouslySetInnerHTML={{ __html: el["BriefDescription"] }}></div></Typography>
														</Grid>
													))}
												</Collapse> */}
											</Grid>
										</Grid> : ''
										}
									</Grid>
									{/* </Grid> */}
								</CardContent>

								<Grid item xs={12} className={classes.block} style={{ marginTop: 82 }}>
									{
										app['isHideManagers'] === 1 && typeof app['EmailToAsk'] === 'string' && app['EmailToAsk'].length > 4
											?
											<Typography variant="body2" color="textSecondary" component="p" className={classes.contentHeader} style={{ textAlign: 'center' }}>
												{translate.Words[`EmailInquiries_${lang}`]} <a className={classes.LinkType13} href={`mailto:${app['EmailToAsk']}&subject=${lang === 'Ru' ? 'вопрос по ' : 'inquiries about the Application '}${app.CodeAsvul}`} >{app['EmailToAsk']}</a>
											</Typography>
											:
											app['isHideManagers'] === 1 && (typeof app['EmailToAsk'] !== 'string' || typeof app['EmailToAsk'] === 'string' && app['EmailToAsk'].length < 4)
												?
												null
												:
												<Typography variant="body2" color="textSecondary" component="p" className={classes.contentHeader} style={{ textAlign: 'center' }}>
													{app[`Managers`] && app[`Managers`].length > 0 ? translate.Words[`FAQ${lang}`] + ':' : ''}
												</Typography>

									}


									{
										app['isHideManagers'] === 1 /*&& typeof app['EmailToAsk'] === 'string' &&  app['EmailToAsk'].length > 4*/
											?
											null
											:
											<Grid
												item
												container
												direction="row"
												justify="center"
												alignItems="flex-start"
												spacing={3}
												style={{ marginTop: 40 }}
											// style={{ maxWidth: 872, margin: '40px auto' }}
											>
												{app[`Managers`] ? app[`Managers`].split(';#;').map((item, index) => (
													<Grid item>
														<CardManager data={item} bgcolor={'#F6F6FB'} />
													</Grid>
												)) : ''}
											</Grid>
									}
								</Grid>
							</Grid>
						</Card>

						<Grid item container className={classes.block} style={{ marginTop: 33 }}>
							{appRecom && appRecom.length > 0
								?
								<Grid item container direction="row" justify="space-between" alignItems="center">
									<Grid item style={{ display: 'flex', flexDirection: 'row' }}>
										<Typography className={classes.Title4}>{translate.Words[`AlsoRecommended_${lang}`]}</Typography>

										<span style={{ marginTop: '6px' }}>
											<Switch color='default' collapseRecomendedApps={collapseRecomendedApps} onChange={handleChange} />
										</span>
									</Grid>

									<Grid item style={{ flexDirection: 'row', display: collapseRecomendedApps ? 'flex' : 'none' }} alignItems="center">
										{renderAddAllBascetBtn()}

										<Grid item className={classes.cntrChangeView}>
											<ChangeViewArray
												selected={view === 'tile' ? 1 : 0}
												handleView={setView}
											/>
										</Grid>
									</Grid>
								</Grid>
								:
								null
							}

							{appRecom && appRecom.length > 0 ?
								<Collapse in={collapseRecomendedApps} collapsedSize={'200px'}>
									<Grid item container style={{ marginTop: 26, padding: 0 }}>
										<Grid item container style={{ marginTop: 14 }}>
											{appRecom ?
												view === 'tile' ?
													<AllAppsTable
														isProd={true}
														basket={true}
														type={'applications'}
														basketChips={basketChips}
														setAppBasket={setAppBasket}
														readLink={false}
														cardArr={appRecom}
														bank={props.bank}
														mt={'16px'}
														kloStatuses={kloStatuses}
														kloUser={props.kloUser}
														loadingKloStatuses={loadingKloStatuses}
														userCollection={props.userCollection}
														saveCollection={props.saveCollection}
														appAlternatives={alternatives}
													/>
													:
													<AllAppsTile
														isProd={true}
														type={'applications'}
														basket={true}
														readLink={props.bankinfo && props.bankinfo.length > 0 && props.bankinfo.readLink}
														basketChips={basketChips}
														setAppBasket={setAppBasket}
														cardArr={appRecom}
														bank={props.bank}
														kloStatuses={kloStatuses}
														kloUser={props.kloUser}
														loadingKloStatuses={loadingKloStatuses}
														userCollection={props.userCollection}
														saveCollection={props.saveCollection}
														appAlternatives={alternatives}
													/>
												:
												''
											}
										</Grid>
									</Grid>
								</Collapse>
								:
								''
							}
						</Grid>
					</Grid>
			}

			<div>
				<Snackbar
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'center',
					}}
					open={snackbar}
					autoHideDuration={3000}
					onClose={closeSnackbar}
					// message="Приложение доавлено в корзину"
					className={classes.root}
				>
					<Grid
						container
						direction="row"
						justify="flex-start"
						alignItems="center"
						className={classes.snackbarPostroot}
					>
						<Avatar style={{ height: 48, width: 48, background: 'rgba(255, 255, 255, 0.2)' }}>
							<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M6.75488 12.2105L10.7894 16L19.7549 7" stroke="white" stroke-width="2" stroke-linecap="round" />
							</svg>
						</Avatar>
						{
							snackbar?.length > 1
								?
								<Typography style={{ marginLeft: 16, fontFamily: 'Cera CY', fontStyle: 'normal', fontWeight: '500', fontSize: '18px', lineHeight: '28px', color: '#FFFFFF' }}>{snackbar[1]}</Typography>
								:
								basketChips.includes(app.ID)
									?
									<Typography style={{ marginLeft: 16, fontFamily: 'Cera CY', fontStyle: 'normal', fontWeight: '500', fontSize: '18px', lineHeight: '28px', color: '#FFFFFF' }}>{translate.Words[`AdtoCartApp_${lang}`]}</Typography>
									:
									<Typography style={{ marginLeft: 16, fontFamily: 'Cera CY', fontStyle: 'normal', fontWeight: '500', fontSize: '18px', lineHeight: '28px', color: '#FFFFFF' }}>{translate.Words[`RemoveApp_${lang}`]}  </Typography>
						}
					</Grid>
				</Snackbar>
			</div>
		</React.Fragment >
		// </ThemeProvider >
	);
}

const useStyles = makeStyles((theme) => ({
	rootWide: {
		// marginTop: 64,
		width: '100%',
		// maxWidth: 345,
		boxShadow: '4px 4px 10px rgba(164, 163, 186, 0.2)',
		borderRadius: theme.spacing(2),
		padding: '38px 111px 100px 112px',
		// padding: theme.spacing(3),
		minWidth: '100%',
		// '&:hover': {
		// 	boxShadow: '4px 4px 20px rgba(164, 163, 186, 0.7)',
		// }

		[theme.breakpoints.down(1367)]: {
			padding: '38px 56px 100px 60px'
		},

		[theme.breakpoints.down(1032)]: {
			padding: '38px 40px 80px 40px'
		},

		[theme.breakpoints.down(696)]: {
			padding: '24px 24px 32px 24px'
		}
	},
	descriptionAttach: {
		color: '#24262A',
		fontSize: '16px',
		fontFamily: 'Cera CY',
		margin: 'auto 30px auto 15px'
		//lineHeight: 24
	},
	attachContainer: {
		display: 'flex',
		marginTop: 10
	},
	attachWrapper: {
		justifyContent: 'center',
		marginTop: 10
	},
	TopTagArray: {
		marginBottom: 37,

		[theme.breakpoints.down(1367)]: {
			maxWidth: 766,
			margin: 'auto'
		},
	},

	AppInfoContainer: {
		marginTop: 37,
		margin: 'auto',

		// [theme.breakpoints.up(1701)]: {
		// 	maxWidth: 1096
		// },

		[theme.breakpoints.down(1367)]: {
			// maxWidth: 766,
			marginTop: 37,
		},

		[theme.breakpoints.down(1032)]: {
			// maxWidth: 568,
			marginTop: 37,
		},

		[theme.breakpoints.down(696)]: {
			// maxWidth: 568,
			marginTop: 22,
		},
	},

	TagsInfoCntr: {
		height: 104,
		borderBottom: '1px solid #EEEEF5',
	},

	EventCntr: {
		height: 24,
		[theme.breakpoints.down(696)]: {
			display: 'none'
		},
	},

	avatar: {
		// backgroundColor: props.iconColor,
		height: 55,
		width: 55,
		borderRadius: 15,
		padding: 11
	},

	icon: {
		marginLeft: 8,
		backgroundColor: '#F6F6FB',
		width: 48,
		height: 48,
		'&:hover': {
			backgroundColor: '#F6F6FB',
		},
		'&:first-child': {
			marginLeft: 'auto',
		}
	},

	content: {
		// height: 289,
		// overflow: 'hidden',
		padding: 0,
		marginTop: 40
	},

	// contentBody: {
	// 	fontSize: '14px',
	// 	fontWeight: '500',
	// 	lineHeight: '18px',
	// 	color: '#000'
	// },

	contentHeader: {
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: 500,
		fontSize: '28px',
		lineHeight: '40px',
		// textAlign: 'center',
		color: '#000000',
		textAlign: 'left'
	},

	contentBody: {
		// marginTop: theme.spacing(1),
		fontSize: '16px',
		fontWeight: '400',
		lineHeight: '24px',
		color: '#8987A2',

		'& * > a': {
			// fontSize: '16px',
			// fontWeight: '400',
			// lineHeight: '24px',
			color: '#24262A !important',
			textDecoration: 'none',
			borderBottom: '1px solid rgba(0, 0, 0, 0.4)',

			'&:hover': {
				color: '#2050FF !important',
				textDecoration: 'none',
				borderBottom: '1px solid #2050FF',
			},

			'& > span': {
				color: 'inherit !important',
				textDecoration: 'none !important',

				'& > font': {
					color: 'inherit !important',
					textDecoration: 'none !important',

					'&:hover': {
						color: 'inherit !important',
						textDecoration: 'none !important',
					}
				}
			}
		},

		'& > h2': {
			fontSize: '20px'
		}
	},

	contentBodyLi: {
		// marginTop: theme.spacing(1),
		fontSize: '16px',
		fontWeight: '400',
		lineHeight: '24px',
		color: '#8987A2',
		paddingLeft: 0,
		paddingInlineStart: "0px !important",

		'&>li': {
			marginBottom: 24,
			paddingLeft: 13,
		},

		'&>div>p>u': {
			textDecoration: 'none'
		},

		'&>div>ul': {
			paddingInlineStart: "20px !important",
			listStyleImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6"><style>circle {fill: %238094FF;}</style><circle cx="3" cy="3" r="3" /></svg>')`,

			'& > ul': {
				paddingInlineStart: "40px !important",
				listStyleImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6"><style>circle {fill: %238987A2;}</style><circle cx="3" cy="3" r="3" /></svg>')`,
			}
		},

		'&>div>ul>li': {
			paddingInlineStart: "20px !important",
			listStyleImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6"><style>circle {fill: %238094FF;}</style><circle cx="3" cy="3" r="3" /></svg>')`,

			'& > ul': {
				paddingInlineStart: "20px !important",
				listStyleImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6"><style>circle {fill: %238987A2;}</style><circle cx="3" cy="3" r="3" /></svg>')`,
			}
		},

		'&>div>ul>li.ql-indent-1': {
			marginLeft: '40px',
			listStyleImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6"><style>circle {fill: %238987A2;}</style><circle cx="3" cy="3" r="3" /></svg>')`,
		},

		'&>div>ul>li.ql-indent-2': {
			marginLeft: '80px',
			listStyleImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6"><style>circle {fill: %238987A2;}</style><circle cx="3" cy="3" r="3" /></svg>')`,
		},

		'&>div>ul>li.ql-indent-3': {
			marginLeft: '120px',
			listStyleImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6"><style>circle {fill: %238987A2;}</style><circle cx="3" cy="3" r="3" /></svg>')`,
		},

		'&>div>ul>li.ql-indent-4': {
			marginLeft: '160px',
			listStyleImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6"><style>circle {fill: %238987A2;}</style><circle cx="3" cy="3" r="3" /></svg>')`,
		},

		'& a': {
			fontSize: '16px',
			fontWeight: '400',
			lineHeight: '24px',
			color: '#24262A !important',
			textDecoration: 'none',
			borderBottom: '1px solid rgba(0, 0, 0, 0.4)',

			'&:hover': {
				color: '#2050FF',
				textDecoration: 'none',
				borderBottom: '1px solid #2050FF',
			},

			'& > span': {
				color: 'inherit !important',
				textDecoration: 'none !important',

				'& > font': {
					color: 'inherit !important',
					textDecoration: 'none !important',

					'&:hover': {
						color: 'inherit !important',
						textDecoration: 'none !important',
					}
				}
			},
		},
	},

	header: {
		padding: 0,
	},

	title: {
		fontSize: '24px',
		lineHeight: '32px',
		fontWeight: '500',
		color: '#24262A',
	},

	subheader: {
		fontSize: '12px',
		lineHeight: '14px',
		fontWeight: 400,
		color: '#8987A2',
		marginBottom: 3
	},

	subbody: {
		fontSize: '16px',
		lineHeight: '24px',
		fontWeight: 400,
		color: '#24262A'
	},

	subbodyRequire: {
		fontSize: '16px',
		lineHeight: '24px',
		fontWeight: 400,
		color: '#24262A',

		'& :first-child': {
			margin: 0
		}
	},

	LinkType12: {
		fontSize: '16px',
		lineHeight: '24px',
		fontWeight: 400,
		color: '#24262A',
		textDecoration: 'none',
		borderBottom: '1px dashed rgba(0, 0, 0, 0.4)',

		'&:hover': {
			color: '#2050FF',
			textDecoration: 'none',
			borderBottom: '1px dashed #2050FF',
		}
	},

	LinkType13: {
		fontSize: '28px',
		lineHeight: '40px',
		fontFamily: 'Cera CY',
		fontWeight: 500,
		color: '#2050FF',
		textDecoration: 'none',
		//color: '#000000',
		//borderBottom: '1px dashed rgba(0, 0, 0, 0.4)',

		'&:hover': {
			color: '#8094FF',
			borderBottom: '1px dashed #8094FF',
			textDecoration: 'none'
		}
	},

	pricePrimary: {
		fontSize: '14px',
		fontWeight: 400,
		lineHeight: '18px',
		color: '#000'
	},

	priceSecondary: {
		fontSize: '14px',
		fontWeight: 400,
		lineHeight: '18px',
		color: '#8987A2'
	},

	rectangle593: {
		width: 120,
		height: 120,
		borderRadius: 80,
		backgroundColor: '#EB505E'
	},

	Rectangle614: {
		backgroundColor: '#F6F6FB',
		borderRadius: 16
	},

	ReleaseDataCaption: {
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: 'normal',
		fontSize: '12px',
		lineHeight: '14px',
		color: '#8987A2'
	},

	ReleaseDataBody: {
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: 'normal',
		fontSize: '16px',
		lineHeight: '24px',
		color: '#000000',
		marginTop: 4
	},

	block: {
		marginTop: 80
	},

	DevelopmentDynamicsBlock: {
		margin: '20px 0'
	},

	DevelopmentDynamicsBlockCaption: {
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: 500,
		fontSize: '13px',
		lineHeight: '16px',
		color: '#24262A'
	},

	DevelopmentDynamicsBlockBody: {
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: 'normal',
		fontSize: '16px',
		lineHeight: '24px',
		color: '#8987A2',
		marginTop: 4
	},

	PrevCard: {
		transform: 'rotate(180deg)',
		display: 'flex'
	},

	NextCard: {
		display: 'flex'
	},

	AvatarContainer: {
		width: 79,

		[theme.breakpoints.down(1032)]: {
			display: 'none'
		}
	},

	AppNameContainer: {
		width: 'calc(100% - 79px)',

		[theme.breakpoints.down(1032)]: {
			width: '100%'
		}
	},

	OutRDC: {
		// maxWidth: 500,
		margin: 'auto',

		[theme.breakpoints.down(1367)]: {
			// maxWidth: 765
		},

		[theme.breakpoints.down(696)]: {
			maxWidth: 'none'
		},
	},

	BaseInfoContainer: {
		[theme.breakpoints.up(1702)]: {
			maxWidth: 648
		},
	},

	AppInsideCardContainer: {
		[theme.breakpoints.up(1702)]: {
			maxWidth: 424
		},

		[theme.breakpoints.down(1702)]: {
			marginTop: 41
		},
	},

	ExtInfoContainer: {
		[theme.breakpoints.up(1701)]: {
			padding: '0 112px'
		},

		[theme.breakpoints.down(1702)]: {
			padding: '0 78px'
		},

		[theme.breakpoints.down(1367)]: {
			padding: 0
		},
	},

	ExtraContainer: {
		marginTop: 56,

		[theme.breakpoints.down(1032)]: {
			display: 'none'
		}
	},

	LicensedContainer: {
		marginTop: 77,

		[theme.breakpoints.down(1032)]: {
			display: 'none'
		}
	},

	ReleaseDataContainer: {
		marginTop: 40,

		[theme.breakpoints.down(1032)]: {
			display: 'none'
		}
	},

	DevDynamicsContainer: {
		marginTop: 40,

		[theme.breakpoints.down(1032)]: {
			display: 'none'
		}
	},

	EventLabel: {
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: 'normal',
		fontSize: '16px',
		lineHeight: '20px',
		color: '#000000',
		paddingLeft: 8
	},

	KeyFunctionCntr: {
		marginTop: 40,

		[theme.breakpoints.down(1367)]: {
			marginTop: 40
		}
	},

	expand: {
		transform: 'rotate(0deg)',
		marginLeft: 'auto',
		transition: theme.transitions.create('transform', {
			duration: theme.transitions.duration.shortest,
		}),
	},

	expandOpen: {
		transform: 'rotate(180deg)',
	},

	BriefDescription: {
		width: '100%',
		marginTop: 39,

		'& > p': {
			color: '#24262A'
		}
	},

	li: {
		'&.ql-indent-1': {
			paddingLeft: '4.5 em'
		}
	},


	snackbarPostroot: {
		padding: 24,
		borderRadius: '16px',
		background: 'rgba(60, 60, 86, 0.9)',
	},

	LinkType2: {
		fontSize: '16px',
		lineHeight: '24px',
		fontWeight: 400,
		color: '#8987A2',
		textDecoration: 'none',

		'&:hover': {
			color: '#24262A',
			textDecoration: 'none',
			borderBottom: '1px solid rgba(0, 0, 0, 0.4)',
		}
	},

	LinkType21: {
		fontSize: '16px',
		lineHeight: '24px',
		fontWeight: 400,
		color: '#8987A2',
		textDecoration: 'none',
		borderBottom: '1px dashed rgba(0, 0, 0, 0.4)',

		'&:hover': {
			color: '#24262A',
			textDecoration: 'none',
			borderBottom: '1px solid rgba(0, 0, 0, 0.4)',
		}
	},

	BC: {
		// height: 96,

		'& ol': {
			flexWrap: 'nowrap'
		}
	},

	Breadcrumb: {
		fontSize: '16px',
		lineHeight: '24px',
		fontWeight: 400,
		color: '#8987A2',
		textDecoration: 'none',

		'&:hover': {
			color: '#24262A',
			textDecoration: 'none',
			borderBottom: '1px solid rgba(0, 0, 0, 0.4)',
		}
	},

	cntrSection: {
		width: 'calc(100% - 262px)',

		[theme.breakpoints.down(696)]: {
			width: '100%'
		}
	},

	cntrArchitecture: {
		width: 269,

		[theme.breakpoints.down(1032)]: {
			width: '33.333333%'
		},

		[theme.breakpoints.down(696)]: {
			width: '100%'
		}
	},

	cntrInterface: {
		width: 179,

		[theme.breakpoints.down(696)]: {
			width: '100%'
		}
	},

	Title4: {
		fontFamily: "Cera CY",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "18px",
		lineHeight: "48px",
		color: "#24262A",
	},

	// li.ql - indent - 2: {
	// 	padding - left: 7.5 em;
	// }

	// li.ql - indent - 3: {
	// 	padding - left: 10.5 em;
	// }

	// li.ql - indent - 4: {
	// 	padding - left: 13.5 em;
	// },
}));